export const configs = () => {
  if (
    window.location.hostname.includes('dev') ||
    window.location.hostname.includes('alpha') ||
    process.env.NODE_ENV === 'development'
  ) {
    return {
      APP_KEY: 'f95f5e49-0fc9-4e3f-8a38-e9096ea96fe6123',
      APP_ID: 'vntravel-group-csp',
      VERSION: '1.0',
      UPLOAD_URL: 'https://assets.dev.tripi.vn',
      BASE_URL: 'https://gate.dev.tripi.vn',
      SOCKET: 'wss://chat.dev.tripi.vn',
    };
  }
  if (window.location.hostname.includes('stag')) {
    return {
      APP_KEY: '741ccvca-8a14-9063-8769-abnn1akax',
      APP_ID: 'vntravel-group-csp',
      VERSION: '1.0',
      UPLOAD_URL: 'https://assets.tripi.vn',
      BASE_URL: 'https://gate.tripi.vn',
      SOCKET: 'wss://chat.tripi.vn',
    };
  }
  return {
    APP_KEY: '741ccvca-8a14-9063-8769-abnn1akax',
    APP_ID: 'vntravel-group-csp',
    VERSION: '1.0',
    UPLOAD_URL: 'https://assets.tripi.vn',
    BASE_URL: 'https://gate.tripi.vn',
    SOCKET: 'wss://chat.tripi.vn',
  };
};
